// if user pressed all selected button numOfTotalRecipents
// is used to calculate total number of recipients

import { TableResult } from "../interests-table/table-context";

// Cap on applicants a single capped bulk action (add note, skip, assign/remove
// owner) can target, however they were selected; mirrored server-side in
// Haven.Domain.Interest.BulkLimits. Message, status change and export are uncapped.
export const MAX_BULK_ACTION_APPLICANTS = 750;

// Cap on owners one bulk assign can add; mirrors BulkLimits.max_owners.
export const MAX_BULK_OWNERS = 25;

/** "1 application" / "3 applications" — a count with its noun pluralized by `s`. */
export const countOf = (count: number, noun: string): string =>
  `${count} ${noun}${count === 1 ? "" : "s"}`;

export const getBulkLimitError = (
  totalSelectedInterests: number,
  { empty, overLimit }: { empty: string; overLimit: string },
): string | null => {
  if (totalSelectedInterests === 0) return empty;
  if (totalSelectedInterests > MAX_BULK_ACTION_APPLICANTS) return overLimit;
  return null;
};

// since the recipients variable only returns the current page's names
export const renderRecipients = (recipients: TableResult[], numOfTotalRecipents = 0, { from, to }: {from: null | number, to: null | number}): string => {
  if (from !== null && to !== null) {
    return `Selected Pages ${from + 1} - ${to + 1}; Total: ${numOfTotalRecipents} applications`;
  }
  if (!recipients || recipients.length < 1) {
    return "";
  }

  const { length } = recipients;
  switch (true) {
    case length === 2:
      return `${recipients[0].applicantName}, and ${recipients[1].applicantName}`;

    case length === 3:
      return (
        `${recipients[0].applicantName
        }, ${
          recipients[1].applicantName
        }, and ${
          recipients[2].applicantName}`
      );

    case length > 3: {
      const firstThreerecipients = recipients.slice(0, 3)
        .map(recipient => recipient.applicantName);
      const restrecipientsCount =
        numOfTotalRecipents > 0 ? numOfTotalRecipents - 3 : recipients.length - 3;
      return `${firstThreerecipients.join(", ")}, and + ${restrecipientsCount} more`;
    }

    default:
      return recipients[0].applicantName;
  }
};
